<template lang="html">
  <div id="reschedulingReceiverClassroom">
    <div
      v-if="reschedulingInfo.receiver.id !== $store.state.userInfo.user_id"
      key="unauthorized"
    >
      <section class="section">
        <h1 class="section-description">授業振替情報を表示する権限がありません</h1>
      </section>
    </div>
    <div
      v-else-if="reschedulingInfo.status !== 'pending'"
      key="got-result"
    >
      <section class="section">
        <h1 class="section-description">指定された授業振替情報は承認または非承認しております</h1>
      </section>
    </div>
    <div
      v-else
      key="receiver-classroom"
    >
      <section>
        <h1>座席選択ページ</h1>
        <div class="Info">
          <h1 class="info-caption">選択された振替日時</h1>
          <div class="Info-data">
            <p>日付：　{{ formattedDate(reschedulingInfo.rescheduled_reservation.date) }}</p>
            <p>時間：　{{reschedulingInfo.rescheduled_reservation.start_time}} 〜 {{reschedulingInfo.rescheduled_reservation.end_time}}の１コマ</p>
          </div>
        </div>
      </section>
      <section>
        <h1>その時間の空き教室状況</h1>
        <p>座席を一つ選択してください</p>
        <div class="classroom_List">
          <ul class="list" v-for="classroom in classrooms">
            <label>
            <li class="content" v-show="classroom.name != 'prohibited'">
              <input
                name="classroom"
                type="radio"
                @change="selectedclassroom(classroom.name)"
              >
              {{ classroom.name }}
            </li>
            </label>
          </ul>
        </div>
      </section>
      <div>
        <p><span class="errormessage">{{ errormessage }}</span></p>
        <el-button
          class="btn"
          @click="cancelButtonClicked()"
        >
        <span>
          戻って修正する
        </span>
        </el-button>
        <el-button
          class="btn"
          @click="onConfirmButtonClicked()"
        >
        <span>
          座席を確定する
        </span>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import {
    mapActions
  } from 'vuex'

  export default {
    name: 'reschedulingReceiverClassroom',
    components: {
    },
    data () {
      return {
        reschedulingInfo: null, // 振替情報（rescheduled_reservationの構造と同じ）
        reservations: null, // その日の予約情報を格納
        classrooms: null, // 全教室情報格納
        reschedulingclassroom: null,
        errormessage: ''
      }
    },
    created () {
      // インスタンス生成後最初に実行
      //  振替情報を格納
      this.reschedulingInfo = this.$store.state.reschedulingInfo
      this.getClassrooms(this.$store.state.userInfo.school_id)
      .then(() => {
        console.log(this.$store.state.classrooms)
        this.classrooms = this.$store.state.classrooms
      })
      .then(() => {
        // 予約情報格納
        this.getReservations({ date: this.reschedulingInfo.rescheduled_reservation.date })
        .then(() => {
          // （非同期処理）読み込みが終わったら状態から予約情報を取得
          this.reservations = this.$store.state.reservations
          for (var i = 0; i < this.reservations.length; ++i) {
            if (this.reservations[i].start_time <= this.reschedulingInfo.rescheduled_reservation.end_time && this.reservations[i].end_time >= this.reschedulingInfo.rescheduled_reservation.start_time) {
              /*  教室の使用判定 */
              for (var j = 0; j < this.classrooms.length; ++j) {
                if (this.classrooms[j].name === this.reservations[i].classroom) {
                  if (this.reservations[i].id !== this.reschedulingInfo.target_reservation.id) {
                    this.classrooms[j].name = 'prohibited'
                  }
                }
              }
            }
          }
        })
        .then(() => {
          if (!(this.classrooms instanceof Object)) {
            alert('教室のフィルタリングに失敗しました。戻って修正するを押して前のページに戻って再度やり直してください。')
          }
          this.classrooms.forEach(function (value, index) {
            if (this.sender.id !== 18 && this.receiver.id !== 18) {
              // 尾川先生と管理者以外の301教室の使用制限
              if (value.name.match('301')) {
                value.name = 'prohibited'
              }
            }
            if (this.rescheduled_reservation.start_time < '15:00') {
              if (value.name.match('307')) {
                value.name = 'prohibited'
              }
            }
          }, this.reschedulingInfo)
        })
      })
    },
    methods: {
      ...mapActions([
        'getReservations',
        'getClassrooms',
        'setReschedulingInfo'
      ]),
      moment: moment,
      formattedDate (date) {
        moment.lang('ja', {
          weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
        })
        return moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）')
      },
      timeDuplicateCheck (date1, date2) {
        // 時間重複チェック
        return (date1.start_time <= date2.end_time && date1.end_time >= date2.start_time)
      },
      selectedclassroom (value) {
        this.reschedulingclassroom = value
      },
      cancelButtonClicked () {
        this.classrooms = null
        this.reschedulingclassroom = null
        this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash)
      },
      onConfirmButtonClicked () {
        if (this.reschedulingclassroom === null) {
          this.errormessage = '教室が選択されていません'
        } else {
          // ボタンクリック時の処理
          this.reschedulingInfo.rescheduled_reservation.classroom_name = this.reschedulingclassroom
          // 日時情報をstoreに保存
          this.setReschedulingInfo(this.reschedulingInfo)
          // 次の1行に次ページヘ飛ぶコードを記入
          this.$router.push('/SpRescheduling/' + this.$route.params.rescheduling_hash + '/Spconfirmation_rcvr')
        }
      }
    }
  }
</script>
<style scoped>
#revieweschedulingReceiverClassroom {
  text-align: center;
  font-family: 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
  margin-bottom: 50px;
}
section {
  border-bottom: solid 2px black;
  text-align: center;
  margin: 10px 5% 10px 5%;
  padding-bottom: 20px;
}
.Info{
  width: auto;
  height: auto;
  display: inline-block;
  border: 1px solid rgb(0, 101, 179);
}
.Info-data{
  padding: 5px;
  text-align: left;
}
.info-caption{
  background-color: rgb(0, 101, 179);
  color: rgb(255, 255, 255);
}
.btn {
  margin: 5px 0 5px 0;
}
.list{
  display: inline-block;
}
.content{
  width: 200px;
  text-align: left;
  font-weight: bold;
  padding: 5px;
  margin: 2px;
  border: 2px solid rgb(255, 159, 159);
  border-radius: 10px;
}
.content:hover{
  background-size: auto;
  color: rgb(255, 255, 255);
  background-color:rgb(255, 159, 159);
}
.errormessage{
  color: rgb(255, 0, 0);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// SpReceiverClassroom.vue?645daed6